"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7486],{

/***/ 61128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* binding */ LabelBox; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 3 modules
var emotion_styled_base_browser_esm = __webpack_require__(61516);
;// CONCATENATED MODULE: ./src/components/atoms/label-box/label-box.style.tsx

var StyledLabelContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e151djlu1"
} : 0)("height:25px;padding:0 10px;display:flex;align-items:center;background-color:", function (containerProps) {
  return containerProps.backgroundColor;
}, ";svg{width:25px;height:25px;margin-left:-10px;margin-right:5px;padding:5px;path{fill:", function (props) {
  return props.theme.shades.white;
}, ";}}" + ( true ? "" : 0));
var StyledLabelText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e151djlu0"
} : 0)("font-size:", function (props) {
  return props.theme.fontSize.copyTextS;
}, ";color:", function (props) {
  return props.color;
}, ";font-weight:600;display:flex;align-items:center;" + ( true ? "" : 0));
// EXTERNAL MODULE: ./src/style/global-style.tsx
var global_style = __webpack_require__(43780);
// EXTERNAL MODULE: ./node_modules/@mui/material/SvgIcon/SvgIcon.js
var SvgIcon = __webpack_require__(2373);
;// CONCATENATED MODULE: ./public/static/labels/couple.svg
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgCouple = function SvgCouple(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 50,
    height: 50,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M15.016 20.713a5.276 5.276 0 0 1 4.562 2.626l.114.205 4.04 12.932 4.04-12.932a5.275 5.275 0 0 1 4.44-2.826l.235-.005h7.5a5.275 5.275 0 0 1 4.562 2.626l.114.205 4.927 15.772c.501.959.08 2.052-.965 2.333a1.598 1.598 0 0 1-1.616-.483l-.094-.116-4.373-12.787c-.053-.153-.284-.082-.242.074 0 0-.094 11.508-.462 12.794-1.547 5.417-11.424 7.79-11.753 7.867l-.008.002.097-20.663c.037-.139-.14-.21-.217-.117l-.023.043-4.375 12.787a1.596 1.596 0 0 1-1.709.599l-.078-.025-.078.025a1.596 1.596 0 0 1-1.616-.483l-.093-.116-4.375-12.787c-.046-.136-.234-.095-.245.025l.004.05L18.192 49S4.815 45.852 4.959 40.344C5.007 38.51 7.5 28.337 7.5 28.337c.037-.139-.141-.21-.218-.117l-.024.043L2.885 41.05a1.597 1.597 0 0 1-1.71.599C.18 41.38-.25 40.373.149 39.447l.063-.131 4.927-15.772a5.274 5.274 0 0 1 4.44-2.826l.235-.005h5.203Zm-2.6-10.631a4.646 4.646 0 1 1-.001 9.292 4.646 4.646 0 0 1 0-9.292Zm23.781 0a4.645 4.645 0 1 1 0 9.29 4.645 4.645 0 0 1 0-9.29Zm-11.74-7.454c1.996-2.03 5.036-2.117 6.827-.326 1.797 1.794 1.722 4.8-.335 6.843-.086.088-4.35 4.33-5.92 5.892a.81.81 0 0 1-1.144 0l-.236-.234a7901.7 7901.7 0 0 0-5.684-5.658c-2.082-1.948-2.182-5.117-.39-6.91 1.793-1.791 4.909-1.612 6.881.393Z",
    fill: "#333",
    fillRule: "evenodd"
  })));
};

/* harmony default export */ var couple = (SvgCouple);
;// CONCATENATED MODULE: ./public/static/labels/family.svg
var family_path;

function family_extends() { family_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return family_extends.apply(this, arguments); }



var SvgFamily = function SvgFamily(props) {
  return /*#__PURE__*/react.createElement("svg", family_extends({
    width: 50,
    height: 50,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), family_path || (family_path = /*#__PURE__*/react.createElement("path", {
    d: "M35.948 11.602a6.44 6.44 0 0 1 5.708 3.458l6.018 18.403c.61 1.171.096 2.507-1.18 2.849-.801.215-1.621-.09-2.087-.731l-5.339-15.612c-.064-.188-.347-.1-.296.09 0 0-.427 20.292-.427 21.17 0 5.262-10.103 8.662-10.103 8.662l-.061-9.877c-.04-3.249.18-3.316.23-3.17l3.282 6.464a1.52 1.52 0 0 0 1.626.569c.994-.267 1.395-1.307.919-2.219l-3.81-9.302a5.019 5.019 0 0 0-4.447-2.693h-5.067a5.019 5.019 0 0 0-4.447 2.693l-3.81 9.302c-.476.912-.075 1.952.918 2.219a1.519 1.519 0 0 0 1.626-.569l3.283-6.464c.05-.146.27-.079.23 3.17L18.651 50s-13.64-3.509-12.763-9.649c.248-1.737 3.455-15.729 3.455-15.729.046-.174-.21-.254-.27-.082L4.21 38.763a1.773 1.773 0 0 1-1.9.665C1.146 39.115.676 37.9 1.234 36.834l5.48-17.543a5.868 5.868 0 0 1 5.202-3.15h5.788a5.85 5.85 0 0 1 2.586.604l.792-1.685a6.444 6.444 0 0 1 5.71-3.458Zm-12.5 7.95a4.419 4.419 0 1 0-.001 8.837 4.419 4.419 0 0 0 0-8.838ZM14.81 4.315a5.168 5.168 0 1 1 0 10.335 5.168 5.168 0 0 1 0-10.335ZM31.37 0a5.167 5.167 0 1 1 0 10.334A5.167 5.167 0 0 1 31.37 0Z",
    fill: "#333",
    fillRule: "evenodd"
  })));
};

/* harmony default export */ var family = (SvgFamily);
;// CONCATENATED MODULE: ./public/static/labels/family-small-child.svg
var family_small_child_path;

function family_small_child_extends() { family_small_child_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return family_small_child_extends.apply(this, arguments); }



var SvgFamilySmallChild = function SvgFamilySmallChild(props) {
  return /*#__PURE__*/react.createElement("svg", family_small_child_extends({
    width: 50,
    height: 50,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), family_small_child_path || (family_small_child_path = /*#__PURE__*/react.createElement("path", {
    d: "M22.008 17.629a3.174 3.174 0 0 1 .814 6.296l-6.358.862.365 10.31 6.752.711a3.39 3.39 0 0 1 2.81 2.153l2.599 6.747c.883 2.29-.754 4.768-3.208 4.856a3.572 3.572 0 0 1-3.3-1.932l-1.694-3.278a1.776 1.776 0 0 0-1.406-.953L8.545 42.346A5.149 5.149 0 0 1 4.41 37.48l-.406-11.438a6.805 6.805 0 0 1 5.069-6.822Zm4.67.846h5.316a9.496 9.496 0 0 1 8.267 4.823l.148.273 4.075 11.692.81 2.329a3.725 3.725 0 0 1-1.563 4.397l-.175.101-8.049 4.376a2.92 2.92 0 0 1-4.134-1.551c-.504-1.344.11-2.845 1.334-3.57l.156-.086 6.023-3.107v-.001l-2.294-6.088c-.089-.258-.457-.165-1.196.04l-.164.045 1.76 5.42-5.255 2.381c-1.071.553-1.538.565-1.757 1.615l-.033.175-1.79-4.474c-.56-1.454-1.854-2.964-3.384-3.236L24.572 34l-6.026-.71-.24-6.81 5.534-.75c2.093-.283 3.616-2.985 3.541-5.096a4.09 4.09 0 0 0-.57-1.949l-.133-.21h5.316Zm-10.516-5.921a5.718 5.718 0 1 1-11.43.406 5.718 5.718 0 0 1 11.43-.406Zm11.15-12.66a8.361 8.361 0 1 1 0 16.723 8.361 8.361 0 0 1 0-16.723Z",
    fill: "#333",
    fillRule: "evenodd"
  })));
};

/* harmony default export */ var family_small_child = (SvgFamilySmallChild);
;// CONCATENATED MODULE: ./public/static/labels/single.svg
var single_path;

function single_extends() { single_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return single_extends.apply(this, arguments); }



var SvgSingle = function SvgSingle(props) {
  return /*#__PURE__*/react.createElement("svg", single_extends({
    width: 50,
    height: 50,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), single_path || (single_path = /*#__PURE__*/react.createElement("path", {
    d: "M28.53 17.65a8.2 8.2 0 0 1 7.266 4.401l7.658 16.632c.779 1.49.123 3.19-1.5 3.625a2.48 2.48 0 0 1-2.657-.93l-5.114-9.021v6.956l.036.08-.036.064v3.283c.282 2.505-1.157 3.994-3.21 5.133-1.159.645-3.944 2.145-6.673 2.06-2.104-.067-3.696-.925-5.76-2.06-2.334-1.281-3.71-3.137-3.71-5.133V31.945l-5.346 9.433a2.48 2.48 0 0 1-2.657.93c-1.623-.436-2.279-2.136-1.5-3.625l7.657-16.632a8.2 8.2 0 0 1 7.267-4.4ZM24.876.063a7.454 7.454 0 1 1 0 14.909 7.454 7.454 0 0 1 0-14.909Z",
    fill: "#333",
    fillRule: "evenodd"
  })));
};

/* harmony default export */ var single = (SvgSingle);
;// CONCATENATED MODULE: ./public/static/labels/friends.svg
var friends_path;

function friends_extends() { friends_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return friends_extends.apply(this, arguments); }



var SvgFriends = function SvgFriends(props) {
  return /*#__PURE__*/react.createElement("svg", friends_extends({
    width: 50,
    height: 50,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), friends_path || (friends_path = /*#__PURE__*/react.createElement("path", {
    d: "M34.361 26.678v13.524c.28 2.497-1.155 3.983-3.201 5.12-1.157.642-3.935 2.137-6.656 2.053-2.097-.067-3.686-.922-5.745-2.054-2.327-1.278-3.7-3.13-3.7-5.119V26.678c0-5.496 5.593-6.011 5.796-6.028h7.817s5.69.43 5.69 6.028Zm-20.25-8.918c1.728 0 1.927.825 3.02 1.968-3.351.888-4.459 3.774-4.459 7.332v13.257c0 2.534 1.539 3.793 3.538 5.214L3.56 42.168C1.465 41.255 0 39.222 0 36.849V23.59c0-3.222 2.689-5.829 6.002-5.829h8.109Zm29.273 0c3.314 0 6.002 2.607 6.002 5.829v13.26c0 2.384-1.474 4.426-3.59 5.331L33.72 45.531s2.764-1.843 2.995-5.213V27.059c0-3.555-1.493-6.437-4.839-7.332 1.094-1.142 1.671-1.967 3.405-1.967h8.103ZM24.694 5.393a6.465 6.465 0 1 1 0 12.931 6.465 6.465 0 1 1 0-12.93Zm14.639-3.472a6.466 6.466 0 1 1-.003 12.932 6.466 6.466 0 0 1 .003-12.932Zm-29.275 0a6.465 6.465 0 1 1-.002 12.93 6.465 6.465 0 0 1 .002-12.93Z",
    fill: "#333",
    fillRule: "evenodd"
  })));
};

/* harmony default export */ var friends = (SvgFriends);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(94581);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./src/components/atoms/label-box/label-box.tsx












var labelClusterType = {
  bestseller: {
    fontColor: global_style/* theme.shades.white */.rS.shades.white,
    backgroundColor: global_style/* theme.labels.bestseller */.rS.labels.bestseller
  },
  highDemand: {
    fontColor: global_style/* theme.shades.white */.rS.shades.white,
    backgroundColor: global_style/* theme.labels.highDemand */.rS.labels.highDemand
  },
  shipRating: {
    fontColor: global_style/* theme.shades.white */.rS.shades.white,
    backgroundColor: global_style/* theme.labels.shipRatings */.rS.labels.shipRatings
  },
  atmosphere: {
    fontColor: global_style/* theme.shades.white */.rS.shades.white,
    backgroundColor: global_style/* theme.labels.quote */.rS.labels.quote
  },
  ageRange: {
    fontColor: global_style/* theme.shades.white */.rS.shades.white,
    backgroundColor: global_style/* theme.colors.main2 */.rS.colors.main2
  },
  productData: {
    fontColor: global_style/* theme.shades.white */.rS.shades.white,
    backgroundColor: global_style/* theme.labels.bestseller */.rS.labels.bestseller
  },
  cabinRating: {
    fontColor: global_style/* theme.shades.white */.rS.shades.white,
    backgroundColor: global_style/* theme.labels.cabinRatings */.rS.labels.cabinRatings
  },
  gastronomyRating: {
    fontColor: global_style/* theme.shades.white */.rS.shades.white,
    backgroundColor: global_style/* theme.labels.gastroRating */.rS.labels.gastroRating
  },
  entertainmentRating: {
    fontColor: global_style/* theme.shades.white */.rS.shades.white,
    backgroundColor: global_style/* theme.labels.entertainmentRating */.rS.labels.entertainmentRating
  },
  serviceRating: {
    fontColor: global_style/* theme.shades.white */.rS.shades.white,
    backgroundColor: global_style/* theme.labels.serviceRating */.rS.labels.serviceRating
  },
  firstCruise: {
    fontColor: global_style/* theme.shades.white */.rS.shades.white,
    backgroundColor: global_style/* theme.colors.dreamdealMain */.rS.colors.dreamdealMain
  },
  experienceLabels: {
    fontColor: global_style/* theme.shades.white */.rS.shades.white,
    backgroundColor: global_style/* theme.colors.dreamdealMain */.rS.colors.dreamdealMain
  },
  experiencedCruiseTraveler: {
    fontColor: global_style/* theme.shades.white */.rS.shades.white,
    backgroundColor: global_style/* theme.colors.dreamdealMain */.rS.colors.dreamdealMain
  },
  ageRangeYoung: {
    fontColor: global_style/* theme.shades.white */.rS.shades.white,
    backgroundColor: global_style/* theme.colors.main2 */.rS.colors.main2
  },
  ageRangeSenior: {
    fontColor: global_style/* theme.shades.white */.rS.shades.white,
    backgroundColor: global_style/* theme.colors.main2 */.rS.colors.main2
  },
  itineraryRating: {
    fontColor: global_style/* theme.shades.white */.rS.shades.white,
    backgroundColor: global_style/* theme.labels.routeRatings */.rS.labels.routeRatings
  },
  excursionsRating: {
    fontColor: global_style/* theme.shades.white */.rS.shades.white,
    backgroundColor: global_style/* theme.labels.routeRatings */.rS.labels.routeRatings
  },
  constellationcouple: {
    icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(couple, {}),
    fontColor: global_style/* theme.shades.white */.rS.shades.white,
    backgroundColor: global_style/* theme.colors.main2 */.rS.colors.main2
  },
  constellationfamily: {
    icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(family, {}),
    fontColor: global_style/* theme.shades.white */.rS.shades.white,
    backgroundColor: global_style/* theme.colors.main2 */.rS.colors.main2
  },
  constellationfamilysmallchildren: {
    icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(family_small_child, {}),
    fontColor: global_style/* theme.shades.white */.rS.shades.white,
    backgroundColor: global_style/* theme.colors.main2 */.rS.colors.main2
  },
  constellationsingle: {
    icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(single, {}),
    fontColor: global_style/* theme.shades.white */.rS.shades.white,
    backgroundColor: global_style/* theme.colors.main2 */.rS.colors.main2
  },
  constellationfriends: {
    icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(friends, {}),
    fontColor: global_style/* theme.shades.white */.rS.shades.white,
    backgroundColor: global_style/* theme.colors.main2 */.rS.colors.main2
  },
  atmospherefamiliar: {
    fontColor: global_style/* theme.shades.white */.rS.shades.white,
    backgroundColor: global_style/* theme.labels.quote */.rS.labels.quote
  },
  atmosphererelaxed: {
    fontColor: global_style/* theme.shades.white */.rS.shades.white,
    backgroundColor: global_style/* theme.labels.quote */.rS.labels.quote
  },
  atmospherechaotic: {
    fontColor: global_style/* theme.shades.white */.rS.shades.white,
    backgroundColor: global_style/* theme.labels.quote */.rS.labels.quote
  },
  atmospherediverse: {
    fontColor: global_style/* theme.shades.white */.rS.shades.white,
    backgroundColor: global_style/* theme.labels.quote */.rS.labels.quote
  },
  atmosphereelegant: {
    fontColor: global_style/* theme.shades.white */.rS.shades.white,
    backgroundColor: global_style/* theme.labels.quote */.rS.labels.quote
  },
  atmosphereloud: {
    fontColor: global_style/* theme.shades.white */.rS.shades.white,
    backgroundColor: global_style/* theme.labels.quote */.rS.labels.quote
  },
  atmosphereboring: {
    fontColor: global_style/* theme.shades.white */.rS.shades.white,
    backgroundColor: global_style/* theme.labels.quote */.rS.labels.quote
  },
  recommend: {
    fontColor: global_style/* theme.shades.white */.rS.shades.white,
    backgroundColor: global_style/* theme.colors.main4 */.rS.colors.main4
  }
};
var LabelBox = function LabelBox(_ref) {
  var label = _ref.label,
      type = _ref.type;
  var labelType = labelClusterType[type];
  var labelBgColor = labelType ? labelType.backgroundColor : global_style/* theme.labels.quote */.rS.labels.quote;
  var labelColor = labelType ? labelType.fontColor : global_style/* theme.shades.white */.rS.shades.white;
  var labelIcon = labelType ? labelType.icon : null;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledLabelContainer, {
    "data-testid": "label-box",
    backgroundColor: (0,colorManipulator/* alpha */.Fq)(labelBgColor, labelIcon ? 0.7 : 1),
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledLabelText, {
      color: labelColor,
      children: [labelIcon ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SvgIcon/* default */.Z, {
        style: {
          backgroundColor: labelBgColor,
          // fontSize: 15,
          verticalAlign: 'middle'
        },
        children: labelType.icon
      }) : null, label]
    })
  });
};

/***/ }),

/***/ 27240:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "F": function() { return /* binding */ LabelledArrow; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 3 modules
var emotion_styled_base_browser_esm = __webpack_require__(61516);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./src/components/atoms/labelled-arrow/labelled-arrow.style.tsx


var StyledTriangledArrow = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ewgsxqb0"
} : 0)("background:", function (props) {
  return props.backgroundColor;
}, ";position:relative;height:", function (props) {
  return props.heightBox;
}, "px;display:flex;align-items:center;&:before,&:after{content:'';z-index:9;position:absolute;top:0;}", function (props) {
  return props.leftTriangle ? /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)("&::before{width:0;height:0;border-style:solid;border-width:", props.heightBox / 2, "px ", Math.floor(props.heightBox / 3), "px ", props.heightBox / 2, "px 0;border-color:transparent ", props.backgroundColor, " transparent transparent;left:-", Math.floor(props.heightBox / 3), "px;}" + ( true ? "" : 0),  true ? "" : 0) : "";
}, " ", function (props) {
  return props.rightTriangle ? /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)("&::after{width:0;height:0;border-style:solid;border-width:", props.heightBox / 2, "px 0 ", props.heightBox / 2, "px ", Math.floor(props.heightBox / 3), "px;border-color:transparent transparent transparent ", props.backgroundColor, ";right:-", Math.floor(props.heightBox / 3), "px;}" + ( true ? "" : 0),  true ? "" : 0) : "";
}, ";" + ( true ? "" : 0));
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./src/components/atoms/labelled-arrow/labelled-arrow.tsx



var LabelledArrow = function LabelledArrow(props) {
  var left = props.left,
      right = props.right,
      backgroundColor = props.backgroundColor,
      textColor = props.textColor,
      heightBox = props.heightBox;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledTriangledArrow, {
    leftTriangle: left,
    rightTriangle: right,
    heightBox: heightBox,
    backgroundColor: backgroundColor,
    textColor: textColor,
    "data-testid": "triangled-arrow",
    children: props.children
  });
};

/***/ }),

/***/ 58761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": function() { return /* binding */ Rating; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/formatting.ts
var formatting = __webpack_require__(62556);
// EXTERNAL MODULE: ./src/utils/translation-service.ts
var translation_service = __webpack_require__(21449);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 3 modules
var emotion_styled_base_browser_esm = __webpack_require__(61516);
// EXTERNAL MODULE: ./src/style/global-style.tsx
var global_style = __webpack_require__(43780);
;// CONCATENATED MODULE: ./src/components/atoms/rating/rating-big/rating-big.style.tsx


var StyledRatingWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ex0fml36"
} : 0)("display:flex;align-items:center;justify-content:center;flex-direction:row;color:", function (props) {
  return props.theme.shades.blackGrey;
}, ";@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{align-items:center;flex-direction:column;}" + ( true ? "" : 0));
var StyledRatingValueBox = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ex0fml35"
} : 0)("background-color:", function (props) {
  return props.theme.colors.main4;
}, ";color:", function (props) {
  return props.theme.shades.white;
}, ";font-weight:400;font-size:", function (props) {
  return props.theme.fontSize.headlineS;
}, ";display:flex;justify-content:center;align-items:baseline;padding:10px;@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{font-size:26px;padding:5px 35px;}@media ", global_style/* mediaQueries.smallDesktopAndUp */.w5.smallDesktopAndUp, "{font-size:28px;}" + ( true ? "" : 0));
var StyledRatingValue = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "ex0fml34"
} : 0)("font-size:", function (props) {
  return props.theme.fontSize.headlineS;
}, ";font-weight:700;padding-right:10px;@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{font-size:50px;}@media ", global_style/* mediaQueries.smallDesktopAndUp */.w5.smallDesktopAndUp, "{font-size:52px;}" + ( true ? "" : 0));
var StyledArrow = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ex0fml33"
} : 0)("width:0;height:0;border-left:8px solid ", function (props) {
  return props.theme.colors.main4;
}, ";border-top:8px solid transparent;border-bottom:8px solid transparent;@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{border-right:15px solid transparent;border-top:10px solid ", function (props) {
  return props.theme.colors.main4;
}, ";border-left:15px solid transparent;}" + ( true ? "" : 0));
var StyledRatingString = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "ex0fml32"
} : 0)("font-size:22px;font-weight:700;padding-bottom:2px;@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{font-size:36px;padding-bottom:5px;}@media ", global_style/* mediaQueries.smallDesktopAndUp */.w5.smallDesktopAndUp, "{font-size:38px;}" + ( true ? "" : 0));
var StyledAmountOfRatings = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "ex0fml31"
} : 0)("font-size:", function (props) {
  return props.theme.fontSize.copyTextM;
}, ";font-weight:400;@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{font-size:", function (props) {
  return props.theme.fontSize.copyTextL;
}, ";}" + ( true ? "" : 0));
var StyledContentWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ex0fml30"
} : 0)("display:flex;flex-direction:column;align-items:flex-start;margin-left:10px;@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{align-items:center;margin-left:0;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./src/components/atoms/rating/rating-big/rating-big.tsx






var RatingBig = function RatingBig(_ref) {
  var value = _ref.value,
      _ref$base = _ref.base,
      base = _ref$base === void 0 ? 10 : _ref$base,
      string = _ref.string,
      amount = _ref.amount;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledRatingWrapper, {
    "data-testid": 'rating-big-component',
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledRatingValueBox, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledRatingValue, {
        children: value
      }), " / ", base]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledArrow, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledContentWrapper, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledRatingString, {
        children: string
      }), amount && amount > 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledAmountOfRatings, {
        "data-testid": 'rating-big-component-total-amount',
        children: (0,formatting/* replaceVal */.yy)((0,translation_service.__)('reviews'), (0,formatting/* numberFormat */.Y4)(amount, {
          maxDecimals: 1
        }), /\[amount]/g)
      })]
    })]
  });
};
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./src/components/atoms/rating/rating.style.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


var rating_style_StyledRatingWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1cqmrqs5"
} : 0)( true ? {
  name: "s5xdrg",
  styles: "display:flex;align-items:center"
} : 0);
var rating_style_StyledRatingValueBox = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1cqmrqs4"
} : 0)("background-color:", function (props) {
  return props.theme.colors.main4;
}, ";color:", function (props) {
  return props.theme.shades.white;
}, ";font-weight:400;display:flex;justify-content:center;align-items:center;", function (props) {
  return props.size === 'M' ? /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)("width:60px;height:28px;font-size:", props.theme.fontSize.copyTextXL, ";" + ( true ? "" : 0),  true ? "" : 0) : /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)("width:47px;height:25px;font-size:", props.theme.fontSize.copyTextS, ";" + ( true ? "" : 0),  true ? "" : 0);
}, ";" + ( true ? "" : 0));
var rating_style_StyledArrow = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1cqmrqs3"
} : 0)("width:0;height:0;border-top:5px solid transparent;border-bottom:5px solid transparent;border-left:5px solid ", function (props) {
  return props.theme.colors.main4;
}, ";" + ( true ? "" : 0));
var StyledRatingStringBox = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1cqmrqs2"
} : 0)( true ? {
  name: "8mvj3g",
  styles: "padding-left:4px;line-height:12px"
} : 0);
var rating_style_StyledRatingString = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1cqmrqs1"
} : 0)("display:block;font-size:", function (props) {
  return props.theme.fontSize.copyTextL;
}, ";font-weight:700;" + ( true ? "" : 0));
var StyledAmount = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1cqmrqs0"
} : 0)("font-size:", function (props) {
  return props.theme.fontSize.copyTextXSS;
}, ";font-weight:400;white-space:nowrap;" + ( true ? "" : 0));
;// CONCATENATED MODULE: ./src/components/atoms/rating/rating.tsx







var Rating = function Rating(_ref) {
  var value = _ref.value,
      _ref$base = _ref.base,
      base = _ref$base === void 0 ? 10 : _ref$base,
      string = _ref.string,
      _ref$amount = _ref.amount,
      amount = _ref$amount === void 0 ? 0 : _ref$amount,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'S' : _ref$size;
  if (!value) return null;
  return size === 'L' ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RatingBig, {
    string: string,
    value: value,
    amount: amount
  }) : (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(rating_style_StyledRatingWrapper, {
    "data-testid": 'rating-component',
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(rating_style_StyledRatingValueBox, {
      size: size,
      children: [value, "/", base]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(rating_style_StyledArrow, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledRatingStringBox, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(rating_style_StyledRatingString, {
        children: string
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledAmount, {
        children: amount && amount > 0 ? (0,formatting/* replaceVal */.yy)((0,translation_service.__)('reviews'), (0,formatting/* numberFormat */.Y4)(amount, {
          maxDecimals: 1
        }), /\[amount]/g) : null
      })]
    })]
  });
};

/***/ }),

/***/ 11178:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": function() { return /* binding */ SimpleGallery; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-swipeable-views/lib/index.js
var lib = __webpack_require__(77314);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 3 modules
var emotion_styled_base_browser_esm = __webpack_require__(61516);
// EXTERNAL MODULE: ./public/static/arrow.svg
var arrow = __webpack_require__(59846);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./src/components/atoms/simple-gallery/simple-gallery.style.tsx



var _excluded = ["showShadow"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }





var DOTSIZE = 10;
var StyledComponentWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eoe7zkm6"
} : 0)( true ? {
  name: "sm6xt5",
  styles: ".react-swipeable-view-container>div{display:flex;justify-content:center;overflow:hidden;}"
} : 0);
var StyledDotContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eoe7zkm5"
} : 0)( true ? {
  name: "1lowt98",
  styles: "z-index:2;position:absolute;bottom:5px;display:flex;justify-content:center;width:100%"
} : 0);
var StyledDotButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "eoe7zkm4"
} : 0)("height:", Math.floor(DOTSIZE + 5), "px;width:", Math.floor(DOTSIZE + 5), "px;cursor:pointer;border:0;padding:0;background:transparent;display:flex;justify-content:center;align-items:center;" + ( true ? "" : 0));
var StyledDot = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eoe7zkm3"
} : 0)("height:", DOTSIZE, "px;width:", DOTSIZE, "px;background:", function (props) {
  return props.active ? props.theme.shades.white : props.theme.shades['white-70'];
}, ";border-radius:", Math.floor(DOTSIZE / 2), "px;box-shadow:0 0 6px 0 rgba(0, 0, 0, 0.5);" + ( true ? "" : 0));
var StyledArrowContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eoe7zkm2"
} : 0)( true ? {
  name: "axu1no",
  styles: "z-index:2;position:absolute;top:0;bottom:0;left:0;right:0;width:auto;height:auto;display:flex;justify-content:space-between;align-items:center;pointer-events:none"
} : 0);
var StyledArrow = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "eoe7zkm1"
} : 0)( true ? {
  name: "jj6r5x",
  styles: "width:25px;padding:0;background:none;border:none;margin-left:5px;margin-right:5px;height:65%;outline:0 none;pointer-events:auto"
} : 0);

var _ref =  true ? {
  name: "peyo6b",
  styles: "filter:drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.5))"
} : 0;

var StyledArrowComponent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(function (_ref2) {
  var showShadow = _ref2.showShadow,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref2, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(arrow/* default */.Z, _objectSpread({}, rest));
},  true ? {
  target: "eoe7zkm0"
} : 0)("fill:", function (props) {
  return props.fill;
}, ";opacity:", function (props) {
  return activeArrow(props) ? '0.2' : '1';
}, ";transform:", function (props) {
  return props.orientation === 'left' ? 'rotate(180deg)' : '';
}, ";", function (props) {
  return props.showShadow ? _ref : '';
}, ";" + ( true ? "" : 0));

var activeArrow = function activeArrow(props) {
  return props.showfadedarrow === 'true' && (props.startitem === 'true' || props.lastitem === 'true');
};
// EXTERNAL MODULE: ./src/style/global-style.tsx
var global_style = __webpack_require__(43780);
;// CONCATENATED MODULE: ./src/components/atoms/simple-gallery/simple-gallery.tsx



function simple_gallery_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function simple_gallery_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? simple_gallery_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : simple_gallery_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var SimpleGallery = function SimpleGallery(_ref) {
  var children = _ref.children,
      _ref$showDots = _ref.showDots,
      showDots = _ref$showDots === void 0 ? true : _ref$showDots,
      _ref$showFadedArrow = _ref.showFadedArrow,
      showFadedArrow = _ref$showFadedArrow === void 0 ? false : _ref$showFadedArrow,
      _ref$arrowColor = _ref.arrowColor,
      arrowColor = _ref$arrowColor === void 0 ? global_style/* theme.shades.white */.rS.shades.white : _ref$arrowColor,
      style = _ref.style,
      _ref$showShadow = _ref.showShadow,
      showShadow = _ref$showShadow === void 0 ? false : _ref$showShadow;

  var _React$useState = react.useState(0),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      view = _React$useState2[0],
      setView = _React$useState2[1];

  var handleNextClick = function handleNextClick(e) {
    e.stopPropagation();

    if (view < children.length - 1) {
      setView(view + 1);
    }
  };

  var handlePrevClick = function handlePrevClick(e) {
    e.stopPropagation();

    if (view > 0) {
      setView(view - 1);
    }
  };

  var isStartItem = view === 0;
  var isLastItem = view === children.length - 1;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledComponentWrapper, {
    "data-testid": 'simple-gallery',
    style: simple_gallery_objectSpread({
      position: 'relative',
      WebkitOverflowScrolling: 'touch'
    }, style),
    children: [children.length > 1 ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledArrowContainer, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledArrow, {
        "data-testid": 'simple-gallery-arrow-left',
        onClick: function onClick(e) {
          return handlePrevClick(e);
        },
        showfadedarrow: showFadedArrow ? 'true' : undefined,
        startitem: String(isStartItem) // @TODO: these will have to be translated
        ,
        "aria-label": "previous",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledArrowComponent, {
          showShadow: showShadow,
          orientation: 'left',
          fill: arrowColor,
          showfadedarrow: showFadedArrow ? 'true' : undefined,
          startitem: String(isStartItem)
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledArrow, {
        "data-testid": 'simple-gallery-arrow-right',
        onClick: function onClick(e) {
          return handleNextClick(e);
        },
        showfadedarrow: showFadedArrow ? 'true' : undefined,
        lastitem: String(isLastItem) // @TODO: these will have to be translated
        ,
        "aria-label": "next",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledArrowComponent, {
          showShadow: showShadow,
          orientation: 'right',
          fill: arrowColor,
          showfadedarrow: showFadedArrow ? 'true' : undefined,
          lastitem: String(isLastItem)
        })
      })]
    }) : null, (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(lib/* default */.ZP, {
      enableMouseEvents: true,
      index: view,
      onChangeIndex: function onChangeIndex(index) {
        setView(index);
      },
      children: children
    }), showDots && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledDotContainer, {
      "data-testid": 'simple-gallery-dots',
      children: children && children.length > 1 && children.map(function (_, i) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledDotButton, {
          onClick: function onClick() {
            return setView(i);
          },
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledDot, {
            "data-testid": "simple-gallery-dot-".concat(i + 1),
            active: i === view ? true : false,
            "aria-selected": i === view ? true : false,
            children: ' '
          }, "klick-dot-".concat(i))
        }, "dot-".concat(i));
      })
    })]
  });
};

/***/ }),

/***/ 16645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A2": function() { return /* binding */ getTranslatedMonth; },
/* harmony export */   "Yi": function() { return /* binding */ formatDepartureReturn; },
/* harmony export */   "iS": function() { return /* binding */ formatDateDDMMMMYYYY; },
/* harmony export */   "zv": function() { return /* binding */ formatDateToNamedMonthAndYear; }
/* harmony export */ });
/* unused harmony exports getMonthTranslationKey, toGermanFormat, toCountryFormat, toDate */
/* harmony import */ var _app_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16835);
/* harmony import */ var _locale__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5875);
/* harmony import */ var _string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9391);
/* harmony import */ var _translation_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21449);




var getMonthTranslationKey = function getMonthTranslationKey(month) {
  if (Number.isInteger(month) && month > 0 && month <= 12) {
    return ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'][month - 1];
  }

  throw new Error("Month is not valid (".concat(month, ") it should be 1 to 12"));
};
var getTranslatedMonth = function getTranslatedMonth(month) {
  return (0,_translation_service__WEBPACK_IMPORTED_MODULE_1__.__)(getMonthTranslationKey(month));
};
var formatDateToNamedMonthAndYear = function formatDateToNamedMonthAndYear(date) {
  if (date && typeof date === 'string' && date.length === 10) {
    var _date$split = date.split('-'),
        _date$split2 = (0,_app_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_date$split, 3),
        year = _date$split2[0],
        month = _date$split2[1],
        day = _date$split2[2];

    if (year && month && day && year.length === 4 && month.length === 2 && day.length === 2) {
      var formated = "".concat(getTranslatedMonth(parseInt(month, 10)), " ").concat(year);
      return formated.charAt(0).toUpperCase() + formated.slice(1);
    }
  }

  return '';
};
var toGermanFormat = function toGermanFormat(date) {
  return Number.isNaN(date.getTime()) ? '' : date.getDate().toString().padStart(2, '0') + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getFullYear();
};
var toCountryFormat = function toCountryFormat(date, market) {
  if (date instanceof Date && !Number.isNaN(date.getTime())) {
    if (market === 'de') {
      return toGermanFormat(date);
    } // @TODO: Handle other markets


    return toGermanFormat(date);
  }

  return '';
};
var toDate = function toDate(date) {
  if (date && typeof date === 'string' && date.length === 10) {
    var splitedDate = date.split('-');

    if (splitedDate.length === 3 && splitedDate[0].length === 4 && splitedDate[1].length === 2 && splitedDate[2].length === 2) {
      var _date = new Date(parseInt(splitedDate[0], 10), parseInt(splitedDate[1], 10) - 1, parseInt(splitedDate[2], 10));

      if (!Number.isNaN(_date.getTime())) {
        return _date;
      }
    }
  }

  return null;
};
var formatDepartureReturn = function formatDepartureReturn(departureDate, returnDate) {
  var isSingleSale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  //@TODO Format date for different countries
  var departureFormated = isSingleSale ? toCountryFormat(toDate(departureDate), _locale__WEBPACK_IMPORTED_MODULE_0__/* .portal */ .l4) : formatDateToNamedMonthAndYear(departureDate);
  var returnFormated = isSingleSale ? toCountryFormat(toDate(returnDate), _locale__WEBPACK_IMPORTED_MODULE_0__/* .portal */ .l4) : formatDateToNamedMonthAndYear(returnDate);

  if (departureFormated && returnFormated && departureFormated === returnFormated) {
    return departureFormated;
  }

  if (departureFormated && returnFormated) {
    return "".concat(departureFormated, " - ").concat(returnFormated);
  }

  if (departureFormated) {
    return departureFormated;
  }

  if (returnFormated) {
    return returnFormated;
  }

  return '';
};
var formatDateDDMMMMYYYY = function formatDateDDMMMMYYYY(date) {
  var dateObj = new Date(date);
  return "".concat(dateObj.getDate(), ". ").concat((0,_string__WEBPACK_IMPORTED_MODULE_3__/* .initialUpper */ .l)(getTranslatedMonth(dateObj.getMonth() + 1)), " ").concat(dateObj.getFullYear());
};

/***/ })

}]);